import React from 'react';
import Props from '../../Components/Props';
import FormikFields from 'components/FormikFields';
import JSXCode from '../../Components/JSXCode';
import { Form, Formik } from 'formik';
import NewDesign from 'components/NewDesign';

const TabSelect = (props) => {
  //! State

  //! Function

  //! Render
  return (
    <div className='component:TabSelect'>
      <Formik initialValues={{ gender: '', genders: [] }} onSubmit={() => {}}>
        {({ values }) => {
          return (
            <Form>
              <code className='tw-block tw-mb-3'>{JSON.stringify(values)}</code>
              <div>
                <div className='tw-grid tw-grid-cols-2 tw-gap-2'>
                  <FormikFields.Select
                    name='gender'
                    label='Gender'
                    placeholder='Select Gender'
                    options={[
                      { label: 'Female', value: 'female' },
                      { label: 'Male', value: 'male' },
                    ]}
                    isClearable
                    required
                  />
                  <FormikFields.Select
                    name='genders'
                    label='Gender(s)'
                    placeholder='Select Gender(s)'
                    options={[
                      { label: 'Female', value: 'female' },
                      { label: 'Male', value: 'male' },
                    ]}
                    closeMenuOnSelect={false}
                    isMulti
                    isClearable
                    required
                  />
                </div>

                <NewDesign.Separator className='tw-my-3' />

                <NewDesign.Badge v2 className='tw-mb-2'>
                  V2
                </NewDesign.Badge>
                <div className='tw-flex tw-gap-2'>
                  <FormikFields.Select
                    name='gender'
                    label='Gender'
                    placeholder='Select Gender'
                    options={[
                      { label: 'Female', value: 'female' },
                      { label: 'Male', value: 'male' },
                    ]}
                    isClearable
                    required
                    v2
                  />

                  <FormikFields.Select
                    name='genders'
                    label='Gender(s)'
                    placeholder='Select Genders'
                    options={[
                      { label: 'Female', value: 'female' },
                      { label: 'Male', value: 'male' },
                    ]}
                    isClearable
                    closeMenuOnSelect={false}
                    isMulti
                    required
                    v2
                  />
                </div>
              </div>
            </Form>
          );
        }}
      </Formik>

      <div className='tw-mt-3'>
        <JSXCode
          code={`<Formik initialValues={{ gender: '', genders: [] }} onSubmit={() => {}}>
{({ values }) => {
    return (
    <Form>
        <code className='tw-block tw-mb-3'>{JSON.stringify(values)}</code>
        <div>
            <div className='tw-grid tw-grid-cols-2 tw-gap-2'>
                <FormikFields.Select
                    name='gender'
                    label='Gender'
                    placeholder='Select Gender'
                    options={[
                        { label: 'Female', value: 'female' },
                        { label: 'Male', value: 'male' },
                    ]}
                    isClearable
                    required
                />
                <FormikFields.Select
                    name='genders'
                    label='Gender(s)'
                    placeholder='Select Gender(s)'
                    options={[
                        { label: 'Female', value: 'female' },
                        { label: 'Male', value: 'male' },
                    ]}
                    closeMenuOnSelect={false}
                    isMulti
                    isClearable
                    required
                />
            </div>

            <NewDesign.Separator className='tw-my-3' />

            <NewDesign.Badge v2 className='tw-mb-2'>V2</NewDesign.Badge>
            <div className='tw-flex tw-gap-2'>
                <FormikFields.Select
                    name='gender'
                    label='Gender'
                    placeholder='Select Gender'
                    options={[
                        { label: 'Female', value: 'female' },
                        { label: 'Male', value: 'male' },
                    ]}
                    isClearable
                    required
                    v2
                />

                <FormikFields.Select
                    name='genders'
                    label='Gender(s)'
                    placeholder='Select Genders'
                    options={[
                        { label: 'Female', value: 'female' },
                        { label: 'Male', value: 'male' },
                    ]}
                    isClearable
                    closeMenuOnSelect={false}
                    isMulti
                    required
                    v2
                />
            </div>
        </div>
    </Form>
    );
}}
</Formik>
`}
        />
      </div>

      <Props
        className='tw-mt-5'
        source={[
          {
            prop: 'name',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'label',
            type: 'any',
            default: 'undefined',
          },
          {
            prop: 'placeholder',
            type: 'string',
            default: 'undefined',
          },
          {
            prop: 'afterOnChange',
            type: '(nextValue) => void',
            default: 'undefined',
          },
          { prop: 'className', type: 'string', default: 'undefined' },
          { prop: 'classNameContainer', type: 'string', default: 'undefined' },
          {
            prop: 'closeMenuOnSelect',
            type: 'boolean',
            default: 'true',
          },
          {
            prop: 'isDisabled',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'isMulti',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'isLoading',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'isClearable',
            type: 'boolean',
            default: 'false',
          },
          {
            prop: 'required',
            type: 'boolean',
            default: 'false',
          },
        ]}
      />
    </div>
  );
};

export default TabSelect;
